import { axios } from "../../../../constants/axiosConfig";
import { message } from "antd";

const icmsModule = JSON.parse(sessionStorage.getItem("icmsModule"));
const BASE_URL = icmsModule
? process.env.REACT_APP_APICLOUD_URL_ICMS
: process.env.REACT_APP_APICLOUD_URL;

// Retornar lista de produtos importados
export function getProducts(filters, extraData, isDuplicated, pCnpj) {
  const aux = JSON.parse(sessionStorage.getItem("eRecuperadorCompany"))
  const session = aux !== null ? aux : null;
  let cnpj = "";
  if (session) cnpj = session.Cnpj;
  let endpoint = `produto/${cnpj}`;
  let newFilter = filters;

  if (isDuplicated) {
    if (filters && filters.includes("sClassificado=0")) {
      newFilter =
        filters && filters.replace("sClassificado=0|sDuplicado=1", "");
    } else {
      newFilter =
        filters && filters.replace("sClassificado<>0|sDuplicado=1", "");
    }
    endpoint += "/divergencia";
  }

  if (extraData) {
    if (extraData.status) {
      if (extraData.status === 4) {
        endpoint += `/${extraData.month}/${extraData.year}/${extraData.status}/divergencia/classificacao`;
      } else {
        endpoint += `/${extraData.month}/${extraData.year}/${extraData.status}`;
      }
    } else if (extraData.month && extraData.year) {
      endpoint += `/${extraData.month}/${extraData.year}`;
    }
  }

  return async (dispatch) => {
    dispatch({ type: "GET_PISCOFINS_REQUEST" });
    await axios
      .get(endpoint + `${newFilter ? newFilter : ""}`)
      .then((response) => {
        dispatch({ type: "GET_PISCOFINS_SUCCESS", payload: response.data });
      })
      .catch(() => {
        dispatch({ type: "GET_PISCOFINS_FAILURE" });
      });
    dispatch({ type: "PISCOFINS_CLEAN" });
  };
}

// Classificar produto
export function classifyProduct(data, filters, extraData) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj,
    filter = filters ? filters : "";
  let endpoint;

  data.Classificacao.filter((item) => {
    if (!item.DataInicio) delete item.DataInicio;
    if (!item.DataFim) delete item.DataFim;
    delete item.Error;
    return item;
  });

  if (data.IdProduto && data.IdProduto.length === 1) {
    endpoint = `produto/${data.IdProduto[0]}/${cnpj}/ncm`;
    if (extraData) {
      if (extraData.status) {
        endpoint = `produto/${data.IdProduto[0]}/${cnpj}/ncm/${extraData.month}/${extraData.year}/${extraData.status}`;
      } else if (extraData.month && extraData.year) {
        endpoint = `produto/${data.IdProduto[0]}/${cnpj}/ncm/${extraData.month}/${extraData.year}`;
      }
    }
  } else {
    endpoint = `produto/${cnpj}/ncm`;
    if (extraData) {
      if (extraData.status) {
        endpoint = `produto/${cnpj}/ncm/${extraData.month}/${extraData.year}/${extraData.status}`;
      } else if (extraData.month && extraData.year) {
        endpoint = `produto/${cnpj}/ncm/${extraData.month}/${extraData.year}`;
      }
    }
  }

  return async (dispatch) => {
    dispatch({ type: "CLASSIFY_PRODUCT_PISCOFINS_REQUEST" });
    await axios
      .post(endpoint + filter, data)
      .then((response) => {
        dispatch({
          type: "CLASSIFY_PRODUCT_PISCOFINS_SUCCESS",
          payload: (response && response.data) || {},
        });
        if (!!(response.data && response.data?.StatusCode === 200)) {
          message.success("Produto(s) classificado(s) com sucesso");
        }
      })
      .catch((error) => {
        dispatch({
          type: "CLASSIFY_PRODUCT_PISCOFINS_FAILURE",
          payload: (error && error.response && error.response.data) || {},
        });
        if (!!(error && error.response && error.response.status !== 403)) {
          message.error("Não foi possível classificar o produto");
        }
      });
    dispatch({ type: "PISCOFINS_CLEAN" });
  };
}

export function exportarProdutos(data, filters, extraData) {
  data.Cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  let endpoint = "relatorio/movimentacao/exportar/" + data.Cnpj;

  if (extraData) {
    if (extraData.status) {
      endpoint += `/${extraData.month}/${extraData.year}/${extraData.status}`;
    } else if (extraData.month && extraData.year) {
      endpoint += `/${extraData.month}/${extraData.year}`;
    }
  }

  return (dispatch) => {
    fetch(`${BASE_URL}/${endpoint}${filters ? filters : ""}`, {
      method: "POST",
      headers: new Headers({
        Authorization: `Bearer ${sessionStorage.getItem("eRecuperadorJwt")}`,
      }),
      body: data,
    })
      .then((response) => {
        if (response.status === 200) {
          const fileName = `${data.Cnpj}.zip`;
          response.blob().then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const downloadLink = document.createElement("a");
            downloadLink.href = url;
            downloadLink.download = fileName;
            downloadLink.click();
            /* inserido o reload abaixo como forma paliativa para não gerar o loop de requisições - Leonardo (16/09) */
            //window.location.reload();
          });

          if (response.status === 400) {
            message.error("Não foi possível gerar o relatório");
          }
        }
      })
      .catch((err) => {
        message.error("Não foi possível gerar o relatório");
      });
  };
}

// Classificar todos os produtos conforme indicação
export function classifySuggestion(data, filters, extraData) {
  let endpoint = "produto/classificar/sugestao";
  data.Cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;

  if (extraData) {
    if (extraData.status) {
      endpoint += `/${extraData.month}/${extraData.year}/${extraData.status}`;
    } else if (extraData.month && extraData.year) {
      endpoint += `/${extraData.month}/${extraData.year}`;
    }
  }

  return async (dispatch) => {
    dispatch({ type: "CLASSIFY_SUGGESTION_PISCOFINS_REQUEST" });
    await axios
      .post(endpoint + `${filters ? filters : ""}`, data)
      .then((response) => {
        dispatch({
          type: "CLASSIFY_SUGGESTION_PISCOFINS_SUCCESS",
          payload: response.data,
        });
        if (response.data?.StatusCode === 200) {
          message.success("Produto(s) classificado(s) com sucesso");
        }
      })
      .catch((error) => {
        if (error && error.response && error.response.status !== 403) {
          message.error("Ocorreu algum problema ao classificar");
        }
        dispatch({
          type: "CLASSIFY_SUGGESTION_PISCOFINS_FAILURE",
          payload: error && error.response && error.response.data,
        });
      });
    dispatch({ type: "PISCOFINS_CLEAN" });
  };
}

// Deletar periodo específico da classificação do produto
export function deletePeriodClassify(data) {
  const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
  return async (dispatch) => {
    await axios
      .delete(`produto/${data.IdProduto}/${cnpj}/ncm/${data.IdNcm}`)
      .then((response) => {
        dispatch({
          type: "DELETE_CLASSIFY_PISCOFINS_SUCCESS",
          payload: response.data,
        });
        if (response.data?.StatusCode === 200) {
          message.success("Periodo deletado com sucesso");
        }
      });
  };
}

// Considerar ou desconsiderar receita
export function getPeriodClassify(filter) {
  let endpoint = `consulta?${filter}`;
  return async (dispatch) => {
    dispatch({ type: "GET_PERIOD_CLASSIFY_PISCOFINS_REQUEST" });
    await axios
      .get(endpoint)
      .then((response) => {
        dispatch({
          type: "GET_PERIOD_CLASSIFY_PISCOFINS_SUCCESS",
          payload: response.data,
        });
      })
      .catch(() => {
        dispatch({ type: "GET_PERIOD_CLASSIFY_PISCOFINS_FAILURE" });
      });
  };
}


// limpar produtos do cache ao exlcuir empresa
export function clearProductsPisCofings() {
  return (dispatch) => {
    dispatch({ type: "PISCOFINS_CLEAR_COMPANY" });
  }
}